/**
 * Created by 58 on 2016/9/24.
 */
/*require('./../style/image-viewer.less');*/
var Component = require('./Component');
var $ = require('jQuery');
var template = require('../template/image-viewer.html');
var ActionType = require('./../constant/ActionType');
var dispatcher = require('./../global/dispatcher');

var deg = 0;
var position = {
  height: null,
  width: null,
  'margin-top': null,
  'margin-left': null
};
var drag = {
  dragContent: null,
  clientX: null,
  clientY: null,
  left: null,
  top: null
};
// 放大
var scale = function (delta, ele) {
  if (position.height < 50 && delta < 0 || position.width < 50 && delta < 0) {
    return false;
  }
  var w = position.width / 20, h = position.height / 20;
  if (delta > 0) {
    position.height = position.height + h;
    position.width = position.width + w;
    position['margin-top'] = position['margin-top'] - h / 2;
    position['margin-left'] = position['margin-left'] - w / 2;
  } else {
    position.height = position.height - h;
    position.width = position.width - w;
    position['margin-top'] = position['margin-top'] + h / 2;
    position['margin-left'] = position['margin-left'] + w / 2;
  }
  ele.css({
    'margin-left': position['margin-left'],
    'margin-top': position['margin-top'],
    'width': position.width,
    'height': position.height
  });
};
// 旋转
var rotate = function (ele, orient) {
  if (orient === "cw") {
    deg += 90;
  } else {
    deg -= 90;
  }
  ele.css("transform", "rotate(" + deg + "deg)");
};
// CSS3属性检测
var supportCss3 = function (style) {
  var prefix = ['webkit', 'Moz', 'ms', 'o'],
    i,
    humpString = [],
    htmlStyle = document.documentElement.style,
    _toHumb = function (string) {
      return string.replace(/-(\w)/g, function ($0, $1) {
        return $1.toUpperCase();
      });
    };

  for (i in prefix)
    humpString.push(_toHumb(prefix[i] + '-' + style));

  humpString.push(_toHumb(style));

  for (i in humpString)
    if (humpString[i] in htmlStyle) return true;

  return false;
};


var ImageViewer = function (options) {
  this._maxWidth = 800;
  this._maxHeight = 500;
  this._imageList = [];

  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
    if (supportCss3("transform"))
      self._element.find(".im-image-rotate").removeClass("im-hide");
  })(this);

  (function (self) {
    var element = self._element;
    element.click(function (e) {
      var target = $(e.target);
      if (!(e.target.tagName == 'IMG' || target.closest(".im-image-toolbar").length !== 0)) {
        self.close();
        return;
      }
      switch (e.target.className) {
        case "im-image-rotate":
          rotate(element.find("img"), "cw");
          break;
        case "im-image-prev":
          self.nextPage("prev");
          break;
        case "im-image-next":
          self.nextPage("next");
          break;
        default:
          break;
      }
    });
    element.on('mousewheel', function (e) {
      if (e.target.tagName != 'IMG') {
        return;
      }
      e.preventDefault();
      var delta = e.deltaY,
        target = element.find(".im-imageviewer-content");
      scale(delta, target);
    });
    element.on("mousedown mousemove mouseup", function (e) {
      var target = e.target,
        left, top,
        content = element.find(".im-imageviewer-content");
      e.preventDefault();
      switch (e.type) {
        case "mousedown":
          if (target.className.indexOf("im-image-draggable") > -1) {
            drag.dragContent = target;
            drag.clientX = e.clientX;
            drag.clientY = e.clientY;
          }
          break;
        case "mousemove":
          if (drag.dragContent !== null) {
            drag.left = position['margin-left'] + (e.clientX - drag.clientX);
            drag.top = position['margin-top'] + (e.clientY - drag.clientY);
            content.css({
              'margin-top': drag.top,
              'margin-left': drag.left
            });
          }
          break;
        case "mouseup":
          if (drag.dragContent !== null) {
            drag.dragContent = null;
            position['margin-left'] = drag.left;
            position['margin-top'] = drag.top;
          }
          break;
        default:
          break;
      }
    });
  })(this);
};
ImageViewer.prototype = Object.create(Component.prototype);

ImageViewer.prototype.init = function () {
  deg = 0;
  drag.dragContent = null;
};
ImageViewer.prototype.close = function () {
  this.setData({
    show: false
  });
  dispatcher.dispatch({
    type: ActionType.FULLSCREEN_CLOSE
  });
};
ImageViewer.prototype.open = function (data) {
  var imageList = data.images;
  this._imageList = imageList;
  var current = data.current;
  if (!imageList[current] || !imageList[current].src) {
    return;
  }
  this.varifyNext(current);
  this.setData({
    show: true,
    current: current,
    src: imageList[current].src,
    width: imageList[current].image_width,
    height: imageList[current].image_height
  });
  dispatcher.dispatch({
    type: ActionType.FULLSCREEN_OPEN
  });
};
ImageViewer.prototype.render = function () {
  var self = this;
  var size = function (imgWidth, imgHeight, radio) {
    var marginLeft, marginTop, contentW, contentH, compute;
    if (imgWidth > self._maxWidth || imgHeight > self._maxHeight) {
      var imgRatio = imgWidth / imgHeight;
      if (imgRatio >= radio) {
        compute = imgHeight * self._maxWidth / imgWidth;
        contentW = self._maxWidth;
        contentH = compute;
        marginLeft = -self._maxWidth / 2;
        marginTop = -compute / 2;
      } else {
        compute = imgWidth * self._maxHeight / imgHeight;
        contentH = self._maxHeight;
        contentW = compute;
        marginTop = -self._maxHeight / 2;
        marginLeft = -compute / 2;
      }
    } else {
      marginLeft = -imgWidth / 2;
      marginTop = -imgHeight / 2;
      contentW = imgWidth;
      contentH = imgHeight;
    }
    imageViewContent.css({
      'margin-left': marginLeft,
      'margin-top': marginTop,
      'width': contentW,
      'height': contentH
    });
    position = {
      height: contentH,
      width: contentW,
      'margin-top': marginTop,
      'margin-left': marginLeft
    };
  };
  var download = function (src) {
    var download = self.getElement().find(".im-image-download");
    var index = src.lastIndexOf("/");
    var name = src.substring(index + 1);
    var href = src + "?attname=" + name;
    download.attr("href", href);
  };
  var element = this._element;
  element.find('img').remove();
  switch (this._data.show) {
    case false:
      element.hide();
      break;
    case true:
      var img = new Image();
      img.src = self._data.src;
      var imageViewContent = element.find('.im-imageviewer-content');
      img.onload = function () {
        img.className = "im-image-draggable";
        var radio = self._maxWidth / self._maxHeight;
        var imgWidth = self._data.width || img.width;
        var imgHeight = self._data.height || img.height;
        imageViewContent.find('img').remove();
        imageViewContent.append(img);
        size(imgWidth, imgHeight, radio);
        self.init();
        element.show();
      };
      download(self._data.src);
      break;
    default:
      break;
  }
};

// 下一张图片
ImageViewer.prototype.nextPage = function (orient) {
  var current = this._data.current;
  var next;
  if (orient === "prev" && current !== 0) {
    next = current - 1;
  } else if (orient === "next" && current != this._imageList.length - 1) {
    next = current + 1;
  }
  this.varifyNext(next);
  this.setData({
    current: next,
    src: this._imageList[next].src,
    width: this._imageList[next].image_width,
    height: this._imageList[next].image_height
  });
};

// 验证是否有下一张图片
ImageViewer.prototype.varifyNext = function (index) {
  var prev = this.getElement().find(".im-image-prev");
  var next = this.getElement().find(".im-image-next");
  prev.removeClass("im-image-disable");
  next.removeClass("im-image-disable");
  if (index === 0) {
    prev.addClass("im-image-disable");
  }
  if (index === this._imageList.length - 1) {
    next.addClass("im-image-disable");
  }
};


module.exports = ImageViewer;
